import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-form-edit",
  "use": "icon-form-edit-usage",
  "viewBox": "0 0 198.4 198.4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 198.4 198.4\" id=\"icon-form-edit\">\r\n<path d=\"M92.1,178.8h99.2c4.1,0,7.1,3.6,6.6,7.2c0,3.6-3.1,6.7-6.6,6.7H92.1c-4.1,0-7.1-3.6-6.6-7.2\r\n\tC85.5,181.9,88.5,178.8,92.1,178.8L92.1,178.8z M120.6,149.8h70.7c4.1,0,7.1,3.1,7.1,7.2c0,4.1-3.1,7.2-7.1,7.2h-70.7\r\n\tc-4.1,0-7.1-3.1-7.1-7.2S116.5,149.8,120.6,149.8z\" />\r\n<path d=\"M179.6,44.7L145,9.6c-5.1-5.2-14.2-5.2-19.8,0L12.7,123.4c-2,2.6-3.6,5.2-4.1,8.3L0,182.9v2.1c0.5,3.6,4.1,6.2,8.1,5.7\r\n\tl53.4-9.3c3.1-0.5,5.6-2.1,7.6-4.1L179.6,63.9C185.2,59.2,185.2,49.9,179.6,44.7L179.6,44.7z M60.5,166.9c-1.5,1.6-3.1,2.6-5.1,2.6\r\n\tl-39.2,7.8c-1,0.5-2-0.5-2-1.6l6.6-36.2c0.5-2.1,1.5-3.6,2.5-5.2l81.9-84.4l34.6,36.2L60.5,166.9z M166.4,58.7l-16.8,17.1L115,39.6\r\n\tl15.3-16c2.5-2.6,7.1-3.1,9.7,0l26.5,24.8C169.4,51.5,169.4,56.1,166.4,58.7z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/form/form-edit.svg
// module id = ymPh
// module chunks = 13